import React from "react"
import { Row, Col } from "react-bootstrap"

import Section from "./section"

const TileItem = ({ data, index }) => {
  const {
    field_heading,
    field_desc,
    //field_cta,
    relationships,
  } = data

  const image = relationships.field_image

  return (
    <>
      <div className="tile">
        {!!image &&
          image.relationships.field_media_image.localFile.childImageSharp
            .original.src && (
            <div className="tile__logo">
              <img
                src={
                  image.relationships.field_media_image.localFile
                    .childImageSharp.original.src
                }
                alt={field_heading}
              />
            </div>
          )}

        <div className="tile__heading">
          <span className="pre">Future Founders</span>
          {field_heading}
        </div>
        <div
          className="tile__desc"
          dangerouslySetInnerHTML={{ __html: field_desc.processed }}
        ></div>
      </div>
    </>
  )
}

const Highlights = ({ data }) => {
  const { field_heading, field_desc, relationships } = data

  const tiles_ref = relationships.field_tiles_ref
  
  return (
    <Section name="tiles" bg="white" id="tiles" heading={field_heading} >
      {!!field_desc && (
        <div
          className="page__blurb text-left"
          dangerouslySetInnerHTML={{ __html: field_desc.processed }}
        ></div>
      )}

      {tiles_ref.length > 0 && (
        <Row className="d-flex justify-content-around">
          {tiles_ref.map((tile, index) => (
            <Col className="tile__wrapper" xs={12} md={6} xl={5} key={index}>
              <TileItem data={tile} index={index} />
            </Col>
          ))}
        </Row>
      )}
    </Section>
  )
}

export default Highlights
